


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCHC8yTUtbJCxLopt_ltaCGoaeFeaoAMjY",
  authDomain: "vision-path-optical.firebaseapp.com",
  projectId: "vision-path-optical",
  storageBucket: "vision-path-optical.firebasestorage.app",
  messagingSenderId: "164847231837",
  appId: "1:164847231837:web:9ad9b9df7c4519ef77beb4"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export